function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_cloud"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m11 7c1.953 0 3.607 1.403 3.934 3.337.048.281.214.529.456.681s.54.189.812.112c.297-.088.558-.13.798-.13 1.654 0 3 1.346 3 3 0 .418-.093.84-.269 1.221-.231.502-.012 1.096.489 1.327.136.063.278.092.418.092.379 0 .74-.216.909-.581.297-.643.453-1.354.453-2.059 0-2.872-2.426-5.231-5.348-4.985-.827-2.377-3.065-4.015-5.652-4.015-.553 0-1 .447-1 1s.447 1 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3.818 3.818c-.718 1.012-1.111 2.214-1.111 3.475 0 .042 0 .084.001.126-1.724.445-3.001 2.013-3.001 3.874 0 2.206 1.794 4 4 4h11c.18 0 .363-.012.553-.033l2.74 2.74c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm2.293 14.707c-1.103 0-2-.897-2-2s.897-2 1.908-2.006c.34.055.736-.078.959-.343.189-.228.27-.527.217-.819-.058-.316-.084-.581-.084-.832 0-.723.205-1.411.563-2.022l8.023 8.022z"
})));

var Svg070Cloud = function Svg070Cloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg070Cloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/070-cloud.0515b6b8.svg";
export { ForwardRef as ReactComponent };